import { render } from "./SVGSideShelfRight.vue?vue&type=template&id=51e1a1e5"
const script = {}

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__